module.exports = "/_next/static/images/reliableSolutions-2x-14b47d91e3ffe5dcf63516d0df13f102.png.webp";